// Debug 
//const url_debug = 'http://localhost:54258';
const url_debug = 'https://personale.battisti.it';


export default {

  getUrl() {
    if (window.location.host.includes("localhost"))
      return url_debug

    return window.location.protocol + "//" + window.location.host
  },

  getUrlApi() {

    let url = this.getUrl();
    if (url.includes("localhost"))
      url += "/api"
    else
      url += "/api/api"

    return url

  },

  getUrlImg() {

    let url = this.getUrl();

    return url + "/risorse/img";
  },

  getUrlUpdate() {

    let url = this.getUrl();

    if (window.location.host.includes("localhost"))
      url = ""
    else
      url += "/index.html"

    return url
  },

}